import React from 'react';
import { Box, useColorMode } from '@chakra-ui/react';
import CheckoutForm from './CheckoutForm';
import { bgColor, borderColor, colorText } from 'config/data';
// import { API } from 'config/api';

const Step2 = ({ setStep, data, access_token, setNft, quantity, updated, intentUsd }) => {
  // const [loading, setLoading] = useState(false);
  // useEffect(() => {
  //   setLoading(true);
  //   let isSubscribed = true;
  //   let config = { headers: { Authorization: `Bearer ${access_token}` } };
  //   API.post(`nft/mintPool/${data.id}/intent`, { method: 'usd' }, config)
  //     .then((res) => {
  //       if (isSubscribed) {
  //         console.log(res);
  //         setLoading(false);
  //       }
  //     })
  //     .catch(() => {
  //       setLoading(false);
  //     });
  //   return () => (isSubscribed = false);
  // }, [access_token, data.id]);
  const { colorMode } = useColorMode();
  return (
    <Box
      w={{ base: '100%', md: '840px' }}
      m="0 auto"
      borderRadius={8}
      borderWidth={1}
      borderColor={borderColor[colorMode]}
      p={{ base: '10px', md: '30px 220px 60px' }}
      bg={bgColor[colorMode]}
      color={colorText[colorMode]}
      mt="30px"
    >
      <CheckoutForm
        nftData={data}
        access_token={access_token}
        setStep={setStep}
        setNft={setNft}
        quantity={quantity}
        updated={updated}
        intentUsd={intentUsd}
      />
    </Box>
  );
};

export default Step2;
